


















































































































































import { Vue, Component } from "vue-property-decorator";
import loading from "@/components/loader/loading.vue";
import { Floors, RoomsStatus, RoomStatus } from "@/api";
import RoomStatusForm from "./RoomStatusForm.vue";
import { dateFormat } from "@/common/date_format";

@Component({
  components: {
    loading,
    RoomStatusForm,
  },
})
export default class RoomStatusLayout extends Vue {
  counter = 0;
  loading = false;
  dialog = false;
  isUpdate = false;
  floorFilter = 0;
  selectedFloorId = 0;
  formatDate = dateFormat;
  selectedRoom: RoomStatus = {
    id: 0,
    status: "",
    createdBy: {
      id: 0,
      name: "",
    },
    roomId: 0,
    roomName: "",
    bedId: 0,
    bedName: "",
  };
  showFilterDate = false;
  formattedFilterDate = "";
  filterDate = "";
  maxDate = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .substring(0, 10);

  async created() {
    this.loading = true;
    const status = this.$store.dispatch("room/fetchRoomsStatus");
    const rooms = this.$store.dispatch("room/fetchCompanyRooms");
    const floors = this.$store.dispatch("floor/fetchCompanyFloors");
    await Promise.all([status, rooms, floors]);
    this.loading = false;
  }

  async selectedDate() {
    await this.$store.dispatch("room/fetchRoomsStatus", this.filterDate);
  }

  get roomsStatus() {
    const rooms =
      (this.$store.getters["room/roomsStatus"] as RoomsStatus[]) || [];

    return rooms.filter((room: RoomsStatus) => {
      if (this.floorFilter) {
        return room.id === this.floorFilter;
      }
      return true;
    });
  }

  get floors() {
    return (this.$store.getters["floor/floors"] as Floors) || [];
  }

  getColor(status: string) {
    switch (status) {
      case "clean":
        return "green";
      case "dirty":
        return "red";
      case "refused":
        return "orange";
      default:
        return "";
    }
  }

  clearSelectedRoom() {
    this.selectedFloorId = 0;
    this.selectedRoom = {
      id: 0,
      status: "",
      createdBy: {
        id: 0,
        name: "",
      },
      roomId: 0,
      roomName: "",
      bedId: 0,
      bedName: "",
    };
  }

  updateRoomStatus(room: RoomStatus, floorId: number | undefined) {
    this.counter++;
    this.isUpdate = room?.status ? true : false;
    this.selectedFloorId = floorId || 0;
    this.selectedRoom = room;
    this.dialog = true;
  }
}
